import classNames from 'classnames';
import { useGetPublicInformationQuery } from '../api/SiteSettingsAPI';
import bannerDefault from '../assets/Banner_default.png';
import { SiteIcon } from './SiteIcon';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import onboardingStyles from '../styles/onboarding.module.css';
import { useBackendImageURL } from '../hooks/useBackendDomain.js';

interface SiteIconType {
	siteName?: boolean;
}

export const SiteLogoBanner: React.FC<SiteIconType> = ({ siteName }) => {
	const { data: siteSettings } = useGetPublicInformationQuery();
	const lightBanner = useBackendImageURL(`/api/siteSettings/image/${siteSettings?.lightBanner}`) || bannerDefault;
	const darkBanner = useBackendImageURL(`/api/siteSettings/image/${siteSettings?.darkBanner}`) || bannerDefault;
	return (
		<div className={onboardingStyles.pageProfileHeader}>
			<div className={onboardingStyles.pageProfileImage}>
				<SiteIcon size={130} />
			</div>
			<div
				className={classNames(onboardingStyles.pageBannerContainer, sharedStyles.lightmode)}
				style={{
					backgroundImage: `url(${lightBanner})`
				}}
			/>
			<div
				className={classNames(onboardingStyles.pageBannerContainer, sharedStyles.darkmode)}
				style={{
					backgroundImage: `url(${darkBanner})`
				}}
			/>
			<div className="space40" />
			{siteName && <div className={sharedStyles.pageBannerTitle}>{siteSettings?.siteName}</div>}
		</div>
	);
};
